module.exports = __webpack_public_path__ + "static/media/moon-icon.735a086a.svg";